module.exports = __webpack_public_path__ + "static/img/2.5377168.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin/2.png
// module id = un3Z
// module chunks = 0